query GetPinnedDomains {
    sessionInstance {
        pinnedDomains
        internalDomains
    }
}
